import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '@mode/capra';
import { DaysOfTheWeek } from '@mode/shared/schedules/contract';
import { dayOfWeekOptions } from './day-of-week-selector.constants';

@Component({
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  selector: 'mode-day-of-week-selector',
  templateUrl: './day-of-week-selector.component.html',
  styleUrls: ['./day-of-week-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DayOfWeekSelectorComponent {
  @Input() dayOfWeek: DaysOfTheWeek = 'Monday';
  @Output() dayOfWeekChanged = new EventEmitter<number>();
  public options = dayOfWeekOptions;

  public handleDayOfWeekChange(daySelected: number) {
    this.dayOfWeekChanged.emit(daySelected);
  }
}
